import React from "react";
import { StyledItem } from './styled';

export default function ListItem(props) {
    return (
        <StyledItem>{props.children}</StyledItem>
    )
}